import { Injectable, isDevMode } from '@angular/core';

export type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'silent';

interface LoggerConfig {
  level: LogLevel;
  prefix?: string;
  timestamp?: boolean;
}

const LEVEL_ORDER: Record<LogLevel, number> = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  silent: 5,
};

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private config: LoggerConfig = {
    level: isDevMode() ? 'debug' : 'info',
    prefix: 'BCR',
    timestamp: true,
  };

  setLevel(level: LogLevel) {
    this.config.level = level;
  }

  private shouldLog(level: LogLevel): boolean {
    return LEVEL_ORDER[level] >= LEVEL_ORDER[this.config.level] && this.config.level !== 'silent';
  }

  private fmt(level: string, message: unknown[]): unknown[] {
    const parts: unknown[] = [];
    if (this.config.timestamp) parts.push(new Date().toISOString());
    if (this.config.prefix) parts.push(`[${this.config.prefix}]`);
    parts.push(`[${level.toUpperCase()}]`, ...message);
    return parts;
  }

  debug(...msg: unknown[]) {
    if (this.shouldLog('debug')) {
      // eslint-disable-next-line no-console
      console.debug(...this.fmt('debug', msg));
    }
  }
  info(...msg: unknown[]) {
    if (this.shouldLog('info')) {
      // eslint-disable-next-line no-console
      console.info(...this.fmt('info', msg));
    }
  }
  warn(...msg: unknown[]) {
    if (this.shouldLog('warn')) {
      // eslint-disable-next-line no-console
      console.warn(...this.fmt('warn', msg));
    }
  }
  error(...msg: unknown[]) {
    if (this.shouldLog('error')) {
      // eslint-disable-next-line no-console
      console.error(...this.fmt('error', msg));
    }
  }
}
